/**
 * Mascota Artemis — ícono oficial (kit 40×40, viewBox 0 0 40 40).
 * @see demo_pet_html/artemis-icon-kit.html — «Ícono sidebar»
 */
export default function ArtemisMascotMark({
  size = 40,
  className = '',
  title = 'Artemis',
  ...props
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role="img"
      aria-label={title}
      {...props}
    >
      <title>{title}</title>
      <rect width="40" height="40" rx="11" fill="#0f1623" />
      <path
        d="M 10 6 A 12 12 0 1 1 10 34 A 8.5 8.5 0 0 0 10 6 Z"
        fill="#1f2d40"
        opacity="0.9"
      />
      <path
        d="M 27 24 C 33 26 34 32 30 35 C 27 37 23 35 22 33"
        fill="none"
        stroke="#e8edf5"
        strokeWidth="3"
        strokeLinecap="round"
        opacity="0.9"
      />
      <ellipse cx="20" cy="26" rx="6" ry="7.5" fill="#e8edf5" />
      <ellipse cx="20" cy="15" rx="5.5" ry="5" fill="#e8edf5" />
      <polygon points="16,13 13,7 18,12" fill="#e8edf5" />
      <polygon points="24,13 27,7 22,12" fill="#e8edf5" />
      <ellipse cx="17.5" cy="14" rx="2" ry="1.5" fill="#00c896" />
      <ellipse cx="22.5" cy="14" rx="2" ry="1.5" fill="#00c896" />
      <ellipse cx="15" cy="33" rx="3.5" ry="2.5" fill="#e8edf5" />
      <ellipse cx="25" cy="33" rx="3.5" ry="2.5" fill="#e8edf5" />
    </svg>
  )
}
